/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';

// eslint-disable-next-line import/no-cycle
import Layout from '../components/layout';
import SEO from '../components/seo';
import HelpHero from '../components/Help/HelpHero';
import { HeroHeading, SmallTitle, BodyText } from '../components/Global';
import HelpFolderArticles from '../components/HelpFolderArticles';
import { theme } from '../styles/GlobalStyles';

const CategorySection = styled.div`
  width: 869px;
  margin: 0 auto 224px;
  padding: 34px 15px;

  a {
    color: ${theme.textColor.blueText};
  }

  li {
    
    &::marker {
      color: ${theme.textColor.silverText};
    }
    div {
      display: inline-block;
      width: 90%;
      margin-left: -10px;
      vertical-align: top;
    }
    &:hover {
      div {
       text-decoration: underline;
      }
    }
  }

  .folder-name {
    color: ${theme.textColor.lightBlack};
  }
  
  @media(max-width: 990px) {
    max-width: 723px;
    width: 100%;
  }
  @media(max-width: 767px) {
    padding: 58px 37px;
  }
`;

const Divider = styled.div`
  width: 100%;
  margin: 45px 0 28px;
  border-bottom: 1px solid ${theme.borderColor.silver};
  @media(max-width: 767px) {
    margin: 40px 0;
    border: 0px;
  }
`;

const helpCategoryTemplate = ({ data, location, pageContext: { category, folders, articles } }) => {
  let pageData = '';
  data.allContentfulHelpCategory.edges.forEach((item) => {
    if (item.node.categoryId === category.id.toString()) {
      pageData = item.node;
    }
    return true;
  });
  return (
    <Layout location={location}>
      <SEO
        title={pageData && pageData.categoryTitle}
        description={pageData && pageData.categoryDescription}
      />
      <HelpHero categoryPage>
        <HeroHeading>{pageData.categoryTitle}</HeroHeading>
        <BodyText>
          {pageData && pageData.categoryDescription}
          { pageData && <Img fluid={pageData.categoryImage.fluid} />}
        </BodyText>
      </HelpHero>
      <CategorySection>
        <div>
          {
            folders.map((folder, i) => {
              const mergedArticles = [].concat(...articles);
              const folderArticles = [];
              mergedArticles.forEach((item) => {
                if (item.folder_id === folder.id && item.status === 2) {
                  folderArticles.push(item);
                }
                return true;
              });
              if (folderArticles.length > 0) {
                return (
                  <div key={folder.id} id={folder.id}>
                    {i !== 0 ? (<Divider />) : (<></>)}
                    <SmallTitle className="folder-name">{folder.name}</SmallTitle>
                    <HelpFolderArticles articles={folderArticles} />
                  </div>
                );
              }
              return true;
            })
          }
        </div>
      </CategorySection>
    </Layout>
  );
};

helpCategoryTemplate.propTypes = {
  data: PropTypes.shape({
    allContentfulHelpCategory: PropTypes.shape({
      edges: PropTypes.shape({
        forEach: PropTypes.shape({
          categoryTitle: PropTypes.string,
          categoryDescription: PropTypes.string,
          categoryId: PropTypes.string,
          categoryImage: PropTypes.shape({
            fluid: PropTypes.shape({
              aspectRatio: PropTypes.number,
              base64: PropTypes.string,
              sizes: PropTypes.string,
              src: PropTypes.string,
              srcSet: PropTypes.string,
              srcSetWebp: PropTypes.string,
              srcWebp: PropTypes.string,
            }),
          }),
        }),
      }),
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    host: PropTypes.string,
    hostname: PropTypes.string,
    href: PropTypes.string,
    key: PropTypes.string,
    origin: PropTypes.string,
    pathname: PropTypes.string,
    port: PropTypes.string,
  }).isRequired,
  pageContext: PropTypes.shape({
    category: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string,
    }).isRequired,
    folders: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }).isRequired,
    ).isRequired,
    articles: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
      }).isRequired,
    ).isRequired,
  }).isRequired,
};

export default helpCategoryTemplate;

export const pageQuery = graphql`
  query HelpCategory {
    allContentfulHelpCategory {
      edges {
        node {
          categoryTitle
          categoryDescription
          categoryId
          categoryImage {
            fluid {
              aspectRatio
              base64
              sizes
              src
              srcSet
              srcSetWebp
              srcWebp
            }
          }
        }
      }
    }
  }
`;
